import React from 'react';
import TeamBadge from './TeamBadge';

function sortSubs(list) {
  return [...list].sort((a, b) => {
    const ma = parseInt(String(a.minute || '0').replace(/\+.*/, ''), 10) || 0;
    const mb = parseInt(String(b.minute || '0').replace(/\+.*/, ''), 10) || 0;
    return ma - mb;
  });
}

function SubArrow({ type }) {
  const isOn = type === 'on';
  return (
    <span
      className={`sw-sub-arrow ${isOn ? 'sw-sub-arrow--on' : 'sw-sub-arrow--off'}`}
      aria-hidden
    >
      <svg viewBox="0 0 12 12" width="12" height="12" fill="currentColor">
        {isOn ? (
          <path d="M6 2l4 5H7v3H5V7H2l4-5z" />
        ) : (
          <path d="M6 10L2 5h3V2h4v3h3L6 10z" />
        )}
      </svg>
    </span>
  );
}

function PlayerOn({ name }) {
  return (
    <span className="sw-sub-player sw-sub-player--on">
      <SubArrow type="on" />
      <span className="sw-sub-player__name">{name}</span>
    </span>
  );
}

function PlayerOff({ name }) {
  return (
    <span className="sw-sub-player sw-sub-player--off">
      <SubArrow type="off" />
      <span className="sw-sub-player__name">{name}</span>
    </span>
  );
}

function SubRow({ sub }) {
  const isSwap = sub.in && sub.out;
  const isBenchOnly = sub.in && !sub.out && !sub.minute;
  const isOnOnly = sub.in && !sub.out && sub.minute;
  const isOutOnly = sub.out && !sub.in;

  return (
    <li
      className={`sw-sub-row ${isSwap ? 'sw-sub-row--swap' : ''} ${isBenchOnly ? 'sw-sub-row--bench' : ''}`}
    >
      {sub.minute ? (
        <span className="sw-sub-row__minute">{sub.minute}&apos;</span>
      ) : (
        <span className="sw-sub-row__minute sw-sub-row__minute--empty">—</span>
      )}
      <div className="sw-sub-row__body min-w-0 flex-1">
        {isSwap && (
          <div className="sw-sub-row__players">
            <PlayerOn name={sub.in} />
            <PlayerOff name={sub.out} />
          </div>
        )}
        {isOnOnly && <PlayerOn name={sub.in} />}
        {isBenchOnly && (
          <div className="sw-sub-row__players">
            <span className="sw-sub-bench-label">Bench</span>
            <PlayerOn name={sub.in} />
          </div>
        )}
        {isOutOnly && <PlayerOff name={sub.out} />}
        {!sub.in && !sub.out && <PlayerOff name="—" />}
        {sub.booking && (
          <span className="sw-sub-row__booking">{sub.booking}</span>
        )}
      </div>
    </li>
  );
}

/** One team's subs / bench — mirrors LineupPanel layout. */
export default function SubstitutionPanel({ teamName, logoUrl, subs = [] }) {
  const sorted = sortSubs(subs);

  return (
    <div className="sw-lineup-panel sw-sub-panel">
      <div className="sw-lineup-panel__head flex items-center gap-2">
        <TeamBadge name={teamName} logoUrl={logoUrl} size={22} />
        <span className="truncate flex-1">{teamName}</span>
        {sorted.length > 0 && (
          <span className="sw-formation-pill">{sorted.length}</span>
        )}
      </div>
      {sorted.length ? (
        <ul>
          {sorted.map((s, i) => (
            <SubRow key={`${s.minute}-${s.in}-${s.out}-${i}`} sub={s} />
          ))}
        </ul>
      ) : (
        <p className="text-xs text-center py-6 px-4" style={{ color: 'var(--sw-muted)' }}>
          No substitutions
        </p>
      )}
    </div>
  );
}

export function splitSubstitutionsBySide(substitutions = []) {
  const home = [];
  const away = [];
  for (const s of substitutions) {
    if (s.side === 'away') away.push(s);
    else home.push(s);
  }
  return { home, away };
}
